import RestService from './RestService';
import IDoc from 'interfaces/IDoc';

export default class DocsService extends RestService<IDoc> {
  constructor() {
    super('docs');
  }
}
